import { EXCEL_BACKEND_BASE_URL } from "../../../services/communication/backendClient";

/**
 * Shared default URL for Linked Excel editor agents/tools.
 * Keep backend URL sourcing centralized to avoid config drift.
 */
export const DEFAULT_EXCEL_API_BASE_URL = EXCEL_BACKEND_BASE_URL;
